import {
  parseISO,
  subMonths,
  addMonths,
  startOfMonth,
  endOfMonth,
  isValid,
} from 'date-fns'

const toDate = (value: string | Date): Date =>
  typeof value === 'string' ? parseISO(value) : value

// set data start date to include one month either side of the 2 "on screen" months
export const getInitialStartDate = (
  startDate: string | Date,
  offsetInMonths: number = 1,
) => startOfMonth(subMonths(toDate(startDate), offsetInMonths))
export const getInitialEndDate = (
  startDate: string | Date,
  offsetInMonths: number = 2,
) => endOfMonth(addMonths(toDate(startDate), offsetInMonths))

export const getInitialDataBounds = (
  startDate?: string | Date,
  offscreenMonthsEitherSide: number = 1,
) => {
  const baseDate =
    startDate == null || !isValid(toDate(startDate))
      ? new Date()
      : toDate(startDate)

  const startDateOffset = offscreenMonthsEitherSide
  const endDateOffset = offscreenMonthsEitherSide + 1 // there are 2 months on screen at any one time -- need to shift by 1
  return {
    initialDataStartDate: getInitialStartDate(baseDate, startDateOffset),
    initialDataEndDate: getInitialEndDate(baseDate, endDateOffset),
  }
}

interface MoveDataWindowArgs {
  dataStartDate: string | Date
  dataEndDate: string | Date
  shiftByMonths?: number
}

export const moveDataWindowForward = ({
  dataStartDate,
  dataEndDate,
  shiftByMonths = 1,
}: MoveDataWindowArgs) => ({
  nextDataStartDate: startOfMonth(
    addMonths(toDate(dataStartDate), shiftByMonths),
  ),
  nextDataEndDate: endOfMonth(addMonths(toDate(dataEndDate), shiftByMonths)),
})

export const moveDataWindowBackwards = ({
  dataStartDate,
  dataEndDate,
  shiftByMonths = 1,
}: MoveDataWindowArgs) => ({
  nextDataStartDate: startOfMonth(
    subMonths(toDate(dataStartDate), shiftByMonths),
  ),
  nextDataEndDate: endOfMonth(subMonths(toDate(dataEndDate), shiftByMonths)),
})
